import Main from './Main'
import Lista from './components/Locadora'
import Novo from './components/NovaLocadora'

export default [
  {
    path: 'pc-locadora',
    name: 'policiacivil.processo.locadora',
    component: Main,
    redirect: { name: 'policiacivil.processo.locadora.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.locadora.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.locadora.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.locadora.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/locadora/routes.js